import { Component, OnInit, ViewChild,ViewEncapsulation } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { LoadService } from '../../services/load.service';
import { LotesService } from '../../services/lotes.service';
import { ProductsService } from '../../services/products.service';
import { TagsService } from '../../services/tags.service';
import { ProductionOrderService } from '../../services/productionOrders.service';
import { ProductionOrderProductsService } from '../../services/productionOrdersProducts.service';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { listLocales } from 'ngx-bootstrap/chronos';
import { NgOption } from '@ng-select/ng-select';
import { Observable }  from 'rxjs/Observable';
import { Subscription } from 'rxjs';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/throttleTime';
import 'rxjs/add/observable/fromEvent';

@Component({
  selector: 'ingresoproduccion',
  templateUrl: './ingresoproduccion.component.html',
  styleUrls: ['./ingresoproduccion.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class IngresoproduccionComponent implements OnInit {
  public load:number;
  public myAngularxQrCode: string;
  public cantidad:Array<any>;
  public saldo:Array<any>;
  public codigoQR:string;
  public signupForm: FormGroup;
  public prefijo:number;
  public idcaja:number;
  public ordenes:any[];
  public productos:any[];
  public producto:any[];
  public lotes:any[];
  public isopen:boolean
  public alert:string;
  public primeracarga:boolean;
  public group:any;
  public bloquear:boolean;
  public union_saldo:boolean;

  constructor(private _tagsService:TagsService,private datePipe: DatePipe,private _localeService: BsLocaleService,private _lotesService:LotesService,private _productsService:ProductsService,private _productionOrderProductsService:ProductionOrderProductsService,private _loaddata: LoadService,private _productionorderService:ProductionOrderService) {
    this.myAngularxQrCode = ' ';
    this.prefijo = 1;
    this.idcaja = 1;
    this.cantidad = [{"id":1,"qr":"Falta Informacion"}];
    this.ordenes = [];
    this.productos = [];
    this.lotes = [];
    this.isopen = false;
    this.alert = "";
    this.primeracarga = false;
    this.producto = [];
    this.saldo = [];
    this.bloquear = false;
    this.union_saldo = false;
  }

/**
 * Se inicia el formulario y se inicia el texto que genera el QR
 */
  ngOnInit() {
    this._loaddata.loadChange(15);
    this._localeService.use('es');
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this.signupForm = new FormGroup({
      'producto':new FormControl(null,[Validators.required]),
      'valorproducto':new FormControl(null,[Validators.required]),
      'especie':new FormControl(null,[Validators.required]),
      'presentacion':new FormControl(null,[Validators.required]),
      'peso':new FormControl(null,[Validators.required]),
      'calibre':new FormControl(null,[Validators.required]),
      'elaboracion':new FormControl(null,[Validators.required]),
      'vencimiento':new FormControl(null,[Validators.required]),
      'lote':new FormControl(null,[Validators.required]),
      'valorlote':new FormControl(null,[Validators.required]),
      'produccion':new FormControl(null,[Validators.required]),
      'valorproduccion':new FormControl(null,[Validators.required]),
      'cliente':new FormControl('Sin Cliente',[Validators.required]),
      'cantidad':new FormControl(null,[Validators.required,Validators.min(0), Validators.max(90)]),
      'saldo':new FormControl(0,[Validators.required,Validators.min(0)]),
      'unionSaldo':new FormControl(false)
    });
    this.signupForm.statusChanges.subscribe(data=>{
       //console.log("status del formulario: ", data);
     })

     this.signupForm.controls['unionSaldo'].valueChanges.subscribe(data=>{
       //console.log("VALOR UNION SALDO: ", data);
     })
    //Texto que genera el codigo QR
    this.signupForm.statusChanges.subscribe((status) => this.myAngularxQrCode = this.prefijo+'-'+this.idcaja+'-'+this.signupForm.value.valorproducto+'-'+this.datePipe.transform(this.signupForm.value.elaboracion, 'dd/MM/yyyy')+'-'+this.signupForm.value.valorlote+'-'+this.signupForm.value.valorproduccion+'-PESO('+this.signupForm.value.peso+'Kg)-'+this.signupForm.value.cliente);
    this.loadPrefix(true);
  }

  loadPrefix(op:boolean){
    let alert = this.alert;
    this.alert = "Calculando prefijo.";
    this.isopen = true;
    this._loaddata.loadChange(30);
    this._tagsService.getPrefix().subscribe(
      (response:any) => {
        if(response.data.length == 0){
          this.prefijo = 1;
          this.alert = alert+". Prefijo "+this.prefijo+" disponible."
          if(op == true){
            this.loadLotes();
          }
          else{
            this._loaddata.loadChange(100);
            this.bloquear = false;
          }
        }
        else{
          this.prefijo = 1 + parseInt(response.data[0].attributes.prefix);
          this.alert = alert+" Prefijo "+this.prefijo+" disponible."
          if(op == true){
            this.loadLotes();
          }
          else{
            this._loaddata.loadChange(100);
            this.bloquear = false;
          }
        }
      },
      (error) => {
        //console.log(error);
        this.showError(error.error.error);
      }
    );
  }

  loadLotes(){
    this.alert = "Cargando lotes disponibles.";
    this.isopen = true;
    this.lotes = [];
    this._loaddata.loadChange(60);

    this._lotesService.getAllSimple().subscribe(
      (response:any) => {

        for(let lote of response.data){
          this.lotes = [...this.lotes,{ id: parseInt(lote.id), code: lote.attributes.code }];
        }

        this._loaddata.loadChange(70);
        this.alert = "Carga correcta de lotes.";
        this.loadOrdenes();
      },
      (error) => {
        //console.log(error);
        this.showError(error.error.error);
      }
    );
  }

  loadOrdenes(){
    this.alert = "Cargando ordenes de producción.";
    this.isopen = true;
    this._loaddata.loadChange(80);
    this._productionorderService.getAllSimple2().subscribe(
      (response:any) => {
        for(let orden of response.data){
          this.ordenes = [...this.ordenes,{ id: parseInt(orden.id), code: orden.attributes.number }];
        }

        this._loaddata.loadChange(100);
        this.alert = "Ordenes de producción cargadas."
        this.onClosedAutomatic();

        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        //console.log(error);
        this.showError(error.error.error);
      }
    );
  }

  onChangeOP(){
    this.alert = "Cargando productos de la OP.";
    this.isopen = true;
    this._loaddata.loadChange(30);
    this.productos = [];

    this._productionorderService.getOne(this.signupForm.get('produccion').value).subscribe(
      (response:any) => {
        this.signupForm.patchValue({
          'cliente': response.data[0].relationships.client.data.attributes.name,
          'valorproduccion':response.data[0].attributes.number
        });

        for(let producto of response.data[0].relationships.products.data){
          this.productos = [...this.productos,{ id: parseInt(producto.id), code: producto.attributes.code}];
        }

        this._loaddata.loadChange(100);
        this.alert = "Ordenes de producción cargadas."
        this.onClosedAutomatic();
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        this.showError(error.error.error);
        //console.log(error);
      }
    );
  }

  /**
   * Carga las caracteristicas de un lote.
   */
  onChangeLotes(){
    this.alert = "Buscando características del lote.";
    this.isopen = true;
    this._loaddata.loadChange(30);

    for(let lote of this.lotes){
      if(lote.id == this.signupForm.get('lote').value){
        this.signupForm.patchValue({
           'especie': 'Ostion',
           'valorlote': lote.code
        });
        break;
      }
    }

    this.alert = "Carga correcta de características del lote.";
    this.onClosedAutomatic();
    this._loaddata.loadChange(100);
  }

  onChangeProducts(){

    this.alert = "Buscando características del producto.";
    this.isopen = true;
    this._loaddata.loadChange(40);
    let id = parseInt(this.signupForm.get('producto').value);

    this._productsService.getOne(id).subscribe(
      (response:any) => {
        this._loaddata.loadChange(60);
        this.producto = response;

        this.signupForm.patchValue({
          'presentacion':response.relationships.properties.data[7].attributes.name+'-'+response.relationships.properties.data[8].attributes.name+'-'+response.relationships.properties.data[11].attributes.name,
          'peso':response.relationships.properties.data[9].attributes.name,
          'calibre':response.relationships.properties.data[10].attributes.name,
          'valorproducto':response.attributes.code
        });

        this._loaddata.loadChange(100);
        this.alert = "Carga correcta de características del producto."
        this.onClosedAutomatic();
      },
      (error) => {
        //console.log(error);
        this.showError(error.error.error);
      }
    );
  }

  onChangeDate(){
    if(this.signupForm.get('elaboracion').value != null){
      this.signupForm.patchValue({
        'vencimiento': this._productionorderService.addDatesYears(this.signupForm.get('elaboracion').value)
      });
    }
  }

/**
 * se generan tantos QR como la cantidad puesta por el usuario.
 * Dentro de this.cantidad esta un objeto con el id y el qr completo.
 */
  public onSubmit():void{
    if(this.bloquear == false && !(this.signupForm.get('cantidad').value == 0 && this.signupForm.get('saldo').value == 0)){
      this.cantidad = [];
      this.saldo = [];
      this.bloquear = true;

      this.alert = "Generando etiquetas QR.";
      this.isopen =true;
      this._loaddata.loadChange(40);
      for (var i = 0; i < this.signupForm.value.cantidad; i++) {
        this.cantidad.push({"id":(i+1),"prefijo":this.prefijo,"producto":this.signupForm.value.producto,"lote":this.signupForm.value.lote,"ordenproduccion":this.signupForm.value.produccion,"fechaelaboracion":this._tagsService.transformDates(this.signupForm.value.elaboracion),"fechavencimiento":this._tagsService.transformDates2(this.signupForm.value.vencimiento),"qr":this.prefijo+'-'+(i+1)+'-'+this.signupForm.value.valorproducto+'-'+this.datePipe.transform(this.signupForm.value.elaboracion, 'dd/MM/yyyy')+'-'+this.signupForm.value.valorlote+'-'+this.signupForm.value.valorproduccion+'-PESO('+this.signupForm.value.peso+'Kg)-'+this.signupForm.value.cliente,"saldo":"0"});
      }

      if(this.signupForm.value.saldo != 0){
        this.saldo.push({"id":(this.cantidad.length+1),"prefijo":this.prefijo,"producto":this.signupForm.value.producto,"lote":this.signupForm.value.lote,"ordenproduccion":this.signupForm.value.produccion,"fechaelaboracion":this._tagsService.transformDates(this.signupForm.value.elaboracion),"fechavencimiento":this._tagsService.transformDates2(this.signupForm.value.vencimiento),"qr":this.prefijo+'-'+(this.cantidad.length+1)+'-'+this.signupForm.value.valorproducto+'-'+this.datePipe.transform(this.signupForm.value.elaboracion, 'dd/MM/yyyy')+'-'+this.signupForm.value.valorlote+'-'+this.signupForm.value.valorproduccion+'-SALDO('+this.signupForm.value.saldo+'Kg)-'+this.signupForm.value.cliente,"saldo":this.signupForm.value.saldo});
      }
      //console.log("CANTIDAD: ", this.cantidad);
      let union = this.signupForm.get('unionSaldo').value;
      let tipo_caja = 1;
      if(union == true){
        this.union_saldo = true;
        tipo_caja = 3;
      }
      else{
        tipo_caja = 1;
        this.union_saldo = false;
      }
      let prov = this._tagsService.transformData2(this.cantidad,this.saldo, tipo_caja);
      //console.log("BODY IMPRIMIR ETIQUETAS: ", prov);

      this._tagsService.saveAll(prov).subscribe(
        response =>{
          /*Se debe usar el setTimeout para que se puedan
          * crear todas las etiquetas antes de enviar a imprimir.
          */
          setTimeout(() => {
            this.print();
            this.cleanForm();
            this.bloquear = false;
            this._loaddata.loadChange(100);
            this.alert = "Etiquetas creadas.";
            this.isopen =true;
            this.ordenes = [];
            this.productos = [];
            this.producto = [];
            this.lotes = [];
          }, 100);

      },
      (error) => {
        //console.log(error);
        this.showError(error.error.error);
        this.loadPrefix(false);
      });
    }else{
      this._loaddata.loadChange(100);
      this.alert = "No se ingreso la cantidad correcta de etiquetas QR.";
      this.isopen =true;
    }
    this.onClosedAutomatic();
  }
  /**
   * Limpia el formulario para volver a utilizarlo despues.
   */
    cleanForm():void{
      this.idcaja = 1;
      this.union_saldo = false;
      this.signupForm.reset();
      this.signupForm = new FormGroup({
        'producto':new FormControl(null,[Validators.required]),
        'valorproducto':new FormControl(null,[Validators.required]),
        'especie':new FormControl(null,[Validators.required]),
        'presentacion':new FormControl(null,[Validators.required]),
        'peso':new FormControl(null,[Validators.required]),
        'calibre':new FormControl(null,[Validators.required]),
        'elaboracion':new FormControl(null,[Validators.required]),
        'vencimiento':new FormControl(null,[Validators.required]),
        'lote':new FormControl(null,[Validators.required]),
        'valorlote':new FormControl(null,[Validators.required]),
        'produccion':new FormControl(null,[Validators.required]),
        'valorproduccion':new FormControl(null,[Validators.required]),
        'cliente':new FormControl('Sin Cliente',[Validators.required]),
        'cantidad':new FormControl(null,[Validators.required,Validators.min(0), Validators.max(90)]),
        'saldo':new FormControl(0,[Validators.required,Validators.min(0)]),
        'unionSaldo':new FormControl(false)
      });

      this.myAngularxQrCode = " ";
      this.loadPrefix(true);
      this.signupForm.statusChanges.subscribe((status) => this.myAngularxQrCode = this.prefijo+'-'+this.idcaja+'-'+this.signupForm.value.valorproducto+'-'+this.datePipe.transform(this.signupForm.value.elaboracion, 'dd/MM/yyyy')+'-'+this.signupForm.value.valorlote+'-'+this.signupForm.value.valorproduccion+'-PESO('+this.signupForm.value.peso+'Kg)-'+this.signupForm.value.cliente);
    }
/**
 * Abre una nueva ventana para imprimir las etiquetas QR contenidas
 * en printContents, que a su vez esta relacionado con print-section del html.
 */
  private print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <style></style>
        </head>
        <body onload="window.print();window.close()">
          ${printContents}
        </body>
      </html>`
    );
    popupWin.document.close();
  }

  /**
   * Cierra el mensaje de alerta.
   */
    onClosed(): void {
      this.isopen = false;
    }

    /**
    * Cierra el mensaje de alerta despues de 5 segundos
    */
    onClosedAutomatic(): void {

        setTimeout(()=>{
        this.isopen = false;
      }, 5000);

    }

  showError(msg:string){
    if(msg == undefined){
      this.alert = 'No tiene permisos para realizar la acción.';
    }
    else{
      this.alert = msg;
    }
    this._loaddata.loadChange(100);
    this.isopen =true;
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/ingresoproduccion/ingresoproduccion.component.ts